import { createRouter, createWebHistory } from 'vue-router';

import { routes as dashboardsCitasRoutes } from '@/router/mod/DashboardsCitas';
import { routes as dashboardsAtencionesRoutes } from '@/router/mod/DashboardsAtenciones';
import { routes as dashboardsPacientesRoutes } from '@/router/mod/DashboardsPacientes';
import { routes as dashboardsFacturacionRoutes } from '@/router/mod/DashboardsFacturacion';
import { routes as financialProcesosRoutes } from '@/router/mod/FinancialProcesos';
import { routes as financialReportesRoutes } from '@/router/mod/FinancialReportes';
import { routes as financialParametrosRoutes } from '@/router/mod/FinancialParametros';
import { routes as medicalProcesosRoutes } from '@/router/mod/MedicalProcesos';
import { routes as medicalReportesRoutes } from '@/router/mod/MedicalReportes';
import { routes as medicalParametrosRoutes } from '@/router/mod/MedicalParametros';
import { routes as adminProcesosRoutes } from '@/router/mod/AdminProcesos';
import { routes as adminReportesRoutes } from '@/router/mod/AdminReportes';
import { routes as adminParametrosRoutes } from '@/router/mod/AdminParametros';

import authRoutes from './authRoutes';
//import dashboardsRoutes from './dashboardsRoutes';
import formsRoutes from './formsRoutes';
import linksRoutes from './linksRoutes';
import masterDetailsRoutes from './masterDetailsRoutes';
//import processRoutes from './processRoutes';
import reportsRoutes from './reportsRoutes';
import simpleFormsRoutes from './simpleFormsRoutes';
import wizardsRoutes from './wizardsRoutes';
import utilsRoutes from './utilsRoutes';
import helpRoutes from './helpRoutes';
import { guideRoutes } from './guidesRoutes';


import Home from '../views/Home.vue';
import MenuPrincipal from '../views/MenuPrincipal.vue';
import AcercaDe from '../views/AcercaDe.vue';

const generalRoutes = [
  { path: '/', 
    name: 'Home',
    component: Home 
  },
  {
    path: '/MenuPrincipal',
    name: 'MenuPrincipal',
    component: MenuPrincipal
  },
  { path: '/acerca-de', 
    name: 'AcercaDe',
    component: AcercaDe 
  }
];

const routes = [
  ...adminParametrosRoutes,
  ...adminProcesosRoutes,
  ...adminReportesRoutes,
  ...medicalParametrosRoutes,
  ...medicalProcesosRoutes,
  ...medicalReportesRoutes,
  ...financialParametrosRoutes,
  ...financialProcesosRoutes,
  ...financialReportesRoutes,
  ...dashboardsAtencionesRoutes,
  ...dashboardsCitasRoutes,
  ...dashboardsPacientesRoutes,
  ...dashboardsFacturacionRoutes,
  ...authRoutes,
//  ...dashboardsRoutes,
  ...formsRoutes,
  ...linksRoutes,
  ...masterDetailsRoutes,
  //...processRoutes,
  ...reportsRoutes,
  ...simpleFormsRoutes,
  ...wizardsRoutes,
  ...utilsRoutes,
  ...helpRoutes,
  ...guideRoutes,
  ...generalRoutes
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;